import React from "react";
import { AddPanelTelegramGrop } from "../../../UI/Groups/Telegram/Add/AddPanelTelegramGrop";

const AddTelegramGroup = () => {
  return (
    <div>
      <AddPanelTelegramGrop />
    </div>
  );
};

export default React.memo(AddTelegramGroup);
